"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _storage = require("../../constants/storage");

var _storage2 = require("../../utils/storage");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: bold;\n  -webkit-font-smoothing: antialiased;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var i18nKey = function i18nKey(key) {
  return "RichTextLib.newFeatures." + key;
};

var StyledHeader = _styledComponents.default.div.withConfig({
  displayName: "NewFeatureShepherd__StyledHeader",
  componentId: "n150ns-0"
})(_templateObject());

var NewFeatureSheperd =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(NewFeatureSheperd, _Component);

  function NewFeatureSheperd() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NewFeatureSheperd);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NewFeatureSheperd)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      settingsKeyLoaded: false,
      isVisible: true
    };

    _this.handleWindowLeave = function () {
      (0, _storage2.removeSessionItem)(_this.hasSeenStorageKey);
    };

    _this.handleButtonClick = function () {
      var _this$props = _this.props,
          settingsKey = _this$props.settingsKey,
          setUserAttribute = _this$props.setUserAttribute;

      _this.setState({
        isVisible: false
      });

      setUserAttribute(settingsKey, true).catch(function (message) {
        console.error('Unable to set user attribute', message);
      });
    };

    _this.isVisible = function () {
      if (!_this.state.settingsKeyLoaded) {
        return false;
      }

      return _this.state.isVisible;
    };

    _this.renderFooter = function () {
      return _react.default.createElement(_UIButton.default, {
        onClick: _this.handleButtonClick,
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('confirm')
      }));
    };

    return _this;
  }

  (0, _createClass2.default)(NewFeatureSheperd, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('unload', this.handleWindowLeave);
      this.props.getUserAttributes([this.props.settingsKey]).then(function (_ref) {
        var attributes = _ref.attributes,
            query = _ref.query;
        var attribute = attributes.find(function (_ref2) {
          var key = _ref2.key;
          return key === _this2.props.settingsKey;
        });
        var userId = query.userId;
        _this2.hasSeenStorageKey = _storage.LOCAL_STORAGE_KEY + ":user-" + userId + ":" + _this2.props.settingsKey;
        var hasDismissed = !!(attribute && attribute.value === 'true');
        var hasSeenInWindow = !!(0, _storage2.getSessionItem)(_this2.hasSeenStorageKey);
        var isVisible = hasDismissed ? false : !hasSeenInWindow;
        (0, _storage2.setSessionItem)(_this2.hasSeenStorageKey, true);

        _this2.setState({
          settingsKeyLoaded: true,
          isVisible: isVisible
        });
      }).catch(console.error);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('unload', this.handleWindowLeave);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          placement = _this$props2.placement,
          header = _this$props2.header,
          width = _this$props2.width,
          className = _this$props2.className,
          settingsKey = _this$props2.settingsKey;
      return _react.default.createElement(_UIPopover.default, {
        tabIndex: "-1",
        "data-test-id": "new-feature-popover-" + settingsKey,
        className: className,
        use: "shepherd",
        placement: placement,
        autoPlacement: "horiz",
        open: this.isVisible(),
        width: width,
        content: {
          header: _react.default.createElement(StyledHeader, null, header),
          body: this.props.body,
          footer: this.renderFooter()
        }
      }, children);
    }
  }]);
  return NewFeatureSheperd;
}(_react.Component);

exports.default = NewFeatureSheperd;
NewFeatureSheperd.propTypes = {
  children: _react.PropTypes.node.isRequired,
  header: _react.PropTypes.node.isRequired,
  body: _react.PropTypes.node.isRequired,
  settingsKey: _react.PropTypes.string.isRequired,
  getUserAttributes: _react.PropTypes.func.isRequired,
  setUserAttribute: _react.PropTypes.func.isRequired,
  width: _react.PropTypes.number,
  placement: _react.PropTypes.string,
  className: _react.PropTypes.string
};
NewFeatureSheperd.defaultProps = {
  width: 350
};
module.exports = exports.default;